module.exports = __webpack_public_path__ + "img/clients-6.5e4bad47.png";